__turbopack_context__.v({
  "answer": "faq-module-scss-module__FX_E3G__answer",
  "faq": "faq-module-scss-module__FX_E3G__faq",
  "faq-page": "faq-module-scss-module__FX_E3G__faq-page",
  "faqs": "faq-module-scss-module__FX_E3G__faqs",
  "faqs-wrapper": "faq-module-scss-module__FX_E3G__faqs-wrapper",
  "headline": "faq-module-scss-module__FX_E3G__headline",
  "question": "faq-module-scss-module__FX_E3G__question",
});
